export const creationSuccess = 'Successfully created service request!';
